import React from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import PostModal from '../../Post/components/PostModal';
import CommentFormModal from '../../Post/components/CommentFormModal';
import CommentsModal from '../../Post/components/CommentsModal';
import Post from '../../Post/components/Post';
import Button from '../../Shared/UI/Button/components/Button';
import ButtonGroup from '../../Shared/UI/ButtonGroup/components/ButtonGroup';

import {
  useFeedState,
  useFeedActions
} from './FeedContext';
import FeedLoader from './FeedLoader';

import { getPosts } from './restApi';

import styles from './Feed.module.scss';

const FeedContent = ({ authenticatedUser }) => {
  const state = useFeedState();
  const {
    setPostModalOpen,
    setCommentFormModalOpen,
    setCommentModalOpen,
    movePostViewState,
    setFeedback,
    setViewState,
    onResponse,
    onError
  } = useFeedActions();

  const postData = state.postDataByViewState?.[state.viewState] || [];
  const lastPageViewed = state.lastPageViewedByViewState?.[state.viewState] || 0;
  const canViewMorePosts = state.canViewMorePostsByViewState?.[state.viewState] ?? true;

  const openPostModal = (e) => {
    e.preventDefault();
    setPostModalOpen(true);
  };

  const handleClosePostModal = () => {
    setPostModalOpen(false);
  };

  const openCommentFormModal = ({commentParentId, commentParentType}) => {
    setCommentModalOpen(false);
    setCommentFormModalOpen(true, commentParentId, commentParentType);
  };

  const handleCloseCommentFormModal = () => {
    setCommentFormModalOpen(false);
  };

  const openCommentModal = ({commentParentId, commentParentType}) => {
    setCommentFormModalOpen(false);
    setCommentModalOpen(true, commentParentId, commentParentType);
  };

  const handleCloseCommentModal = () => {
    setCommentModalOpen(false);
  };

  const setFeedbackMessage = (message) => {
    setFeedback(message, 'success');
  };

  const setFeedbackVariant = (variant) => {
    setFeedback(state?.feedbackMessage || '', variant);
  };

  const posts = () => {
    return postData.map(post => {
      return (
        <Post
          key={post.id}
          post={post}
          handleOpenCommentFormModal={openCommentFormModal}
          handleOpenCommentModal={openCommentModal}
          setFeedbackMessage={setFeedbackMessage}
          setFeedbackVariant={setFeedbackVariant}
          moveViewState={movePostViewState}
        />
      );
    });
  };

  const loadMorePosts = () => {
    getPosts({
      lastPageViewed,
      viewState: state?.viewState || 'approved',
      onResponse: (data) => onResponse(data),
      onError: (feedback) => onError(feedback),
    });
  };

  return (
    <>
      <div id={styles.infinitScrollContainer}>
        <InfiniteScroll
          dataLength={postData.length}
          next={loadMorePosts}
          hasMore={canViewMorePosts}
          loader={<h4>Loading...</h4>}
          endMessage={
            <p style={{ textAlign: 'center' }}>
              <b>You've seen all the posts</b>
            </p>
          }
          scrollableTarget="html"
        >
          <div id={styles.createPostsContainer}>
            {!!authenticatedUser && authenticatedUser.canAdministratePosts && (
              <div className={styles.viewStateButtons}>
                <ButtonGroup>
                  <Button
                    variant="secondary"
                    pressed={state?.viewState === 'draft'}
                    onClick={() => { setViewState('draft') }}
                  >
                    Drafts
                  </Button>
                  <Button
                    variant="secondary"
                    pressed={state?.viewState === 'pending_approval'}
                    onClick={() => { setViewState('pending_approval') }}
                  >
                    In Review
                  </Button>
                  <Button
                    variant="secondary"
                    pressed={state?.viewState === 'approved'}
                    onClick={() => { setViewState('approved') }}
                  >
                    Published
                  </Button>
                </ButtonGroup>
              </div>
            )}
            <div id={styles.createPostsBtn}>
              <Button variant="primary" onClick={openPostModal}>Make a post</Button>
            </div>
          </div>
          {posts()}
        </InfiniteScroll>
      </div>
      <PostModal
        modalOpen={state?.postModalOpen}
        handleCloseWizard={handleClosePostModal}
      />
      <CommentFormModal
        modalOpen={state?.commentFormModalOpen}
        handleCloseModal={handleCloseCommentFormModal}
        parentId={state?.commentParentId}
        parentType={state?.commentParentType}
      />
      {state?.commentModalOpen && (
        <CommentsModal
          modalOpen={state?.commentModalOpen}
          handleCloseModal={handleCloseCommentModal}
          parentId={state?.commentParentId}
          parentType={state?.commentParentType}
          handleOpenCommentFormModal={openCommentFormModal}
          handleOpenCommentModal={openCommentModal}
        />
      )}
    </>
  );
};

const Feed = ({ authenticatedUser }) => {
  return (
    <>
      <FeedLoader />
      <FeedContent authenticatedUser={authenticatedUser} />
    </>
  );
};

export default Feed;
